import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-043f41d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controlls hide-sp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.move('prev'))),
      class: "btn-prev"
    }, _toDisplayString(_ctx.prevLabel), 1),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.move('today'))),
      class: "btn-current"
    }, _toDisplayString(_ctx.todayLabel), 1),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.move('next'))),
      class: "btn-next"
    }, _toDisplayString(_ctx.nextLabel), 1)
  ]))
}